<template>
  <v-app-bar id="app-toolbar" app color="primary">
    <div class="nav-left">
      <router-link :to="{ name: 'frontpage' }" v-slot="{ href, navigate }">
        <a :href="href" @click="navigate">
          <v-toolbar-title id="app-title" color="white">cvr.dev</v-toolbar-title>
        </a>
      </router-link>
      <div id="app-bar-menu-items">
        <a rel="noopener noreferrer" target="_blank" :href="docsUrl">
          <div class="app-bar-menu-item">
            Dokumentation<v-icon size="small" color="white">mdi-open-in-new</v-icon>
          </div>
        </a>
        <router-link :to="{ name: 'prices' }">
          <div class="app-bar-menu-item">Priser</div>
        </router-link>
      </div>
    </div>

    <v-spacer></v-spacer>

    <div id="app-bar-menu-items">
      <div v-show="!this.isLoggedIn" class="auth-buttons">
        <router-link style="text-decoration: none" :to="{ name: 'signup' }">
          <v-btn class="button-spacer" color="accent" variant="elevated"> Opret konto </v-btn>
        </router-link>
        <router-link style="text-decoration: none" :to="{ name: 'signin' }">
          <v-btn color="secondary" variant="elevated"> Log ind </v-btn>
        </router-link>
      </div>

      <div class="auth-buttons">
        <router-link v-show="this.isLoggedIn" :to="{ name: 'profile' }">
          <div class="app-bar-menu-item">Profil</div>
        </router-link>
      </div>
      <router-link v-show="this.isLoggedIn" :to="{ name: 'signout' }">
        <v-btn v-show="this.isLoggedIn" variant="text" icon="mdi-logout" color="white" title="Log ud">
        </v-btn>
      </router-link>
    </div>
  </v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";
import config from "@/config.js";

export default {
  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
  },
  data() {
    return {
      docsUrl: config.DocsUrl,
    };
  },
  methods: {
    signOut: function () {
      this.$store.dispatch("auth/signOut").then(() => {
        this.$router.push({ name: "signin" });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#app-toolbar {
  padding-left: 16px;
  padding-right: 16px;
  height: auto !important;
  min-height: 56px;

  ::v-deep .v-toolbar__content {
    flex-wrap: wrap;
    height: auto !important;
    min-height: 56px;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .v-application a,
  .v-application a:visited,
  .v-application a:hover,
  .v-application a:active,
  a,
  a:visited,
  a:hover,
  a:active {
    text-decoration: none;
  }
}

#app-title {
  font-size: 2rem;
  font-weight: 700;
  color: #eee;
}

#app-bar-menu-items {
  margin-left: 2rem;
  height: 100%;
  display: flex;
}

.app-bar-menu-item {
  height: 100%;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  color: #eee;

  &:hover {
    background: #2a2a2a;
  }

}


@media (max-width: 600px) {
  .app-bar-menu-item {
    padding: 0 0.3rem;
  }

  #app-bar-menu-items {
    margin-left: 1rem;
    margin-bottom: 10px;
  }
}

.button-spacer {
  margin-right: 1rem;
}

.auth-buttons {
  display: flex;
  align-items: left;
}

.nav-left {
  display: flex;
  align-items: left;
  height: 100%;
}
</style>
